export default __webpack_public_path__ + "static/media/w_m_2024_a.89e87883.jpg";